export const ROOT_NODE = 'EVENTS_ROOT_NODE';
//# sourceMappingURL=viewer.js.map